export { default as createOneFavoriteTopicMutation } from './create-one-favorite-topic-mutation';
export { default as favoriteTopicFragment } from './favorite-topic-fragment';
